<div class="component-container">
    <div class="update-email-container">
        <h1>Update Email</h1>
        <p class="description">Change your email address associated with your account.</p>
        
        <div class="success-message" id="successMessage">
            Verification email sent! Please check your new email to complete the update.
        </div>
        
        <div class="info-box">
            After updating your email, we'll send a verification link to your new address. 
            Your email won't be updated until you verify the new address.
        </div>
        
        <form id="updateEmailForm" #form="ngForm" (ngSubmit)="updateEmail()">
            <div class="form-group">
                <label for="currentEmail">Current Email</label>
                <input type="email" name="currentEmail" value="user@example.com" [(ngModel)]="currentEmail" disabled>
            </div>
            
            <div class="form-group">
                <label for="newEmail">New Email</label>
                <input type="email" name="newEmail" placeholder="Enter new email address" [(ngModel)]="newEmail" required>
                <div class="error-message" id="newEmailError"></div>
            </div>
            
            <div class="form-group">
                <label for="confirmEmail">Confirm New Email</label>
                <input type="email" name="confirmEmail" placeholder="Confirm new email address" [(ngModel)]="confirmEmail" required>
                <div class="error-message" id="confirmEmailError"></div>
            </div>
            
            <div class="form-group">
                <label for="password">Password</label>
                <div class="password-container">
                    <input type="password" name="password" placeholder="Enter your password to confirm" [(ngModel)]="password" required autocomplete="off">
                    <button type="button" class="toggle-password" aria-label="Toggle password visibility">Show</button>
                </div>
                <div class="error-message" id="passwordError"></div>
            </div>
            
            <div class="button-group">
                <button type="submit" class="btn btn-primary" [disabled]="form.invalid" (click)="updateEmail()">Update Email</button>
            </div>
            
            <p class="back-link"><a [routerLink]="['/settings']" [queryParams]="{ tab: 'account' }">Back to settings</a></p>
        </form>
    </div>
</div>